// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1eNfm","header":"ClearentDisclaimer_header__3kDL7","inner":"ClearentDisclaimer_inner__13prp"};